import filter from 'lodash/filter';
import CHUCK_CONSTANTS from './chuck-constants';

export const ALERT_TYPE_SUCCESS = 'SUCCESS';
export const ALERT_TYPE_ERROR = 'ERROR';
export const ALERT_TYPE_IN_PROGRESS = 'IN_PROGRESS';
export const ALERT_TYPE_WARNING = 'WARNING';
export const ALERT_TYPE_LOADING = 'LOADING';
export const ALERT_TYPE_PHONE = 'PHONE_ALERT';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_DISPLAY_FORMAT = 'h:mm A';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ssZ';
export const MONTH_YEAR_FORMAT = 'MMMM YYYY';
export const DEPOSIT_CAP_START_DATE = '2024-06-30';

export const BUILDING = 'BUILDING';
export const LISTING = 'LISTING';

export const MAPBOX_STYLE = 'mapbox://styles/nestio/cj5bm415v1lmb2rmccuf77etr';

export const LISTING_PRIMARY_FILTERS = [
    'canonical_building_id',
    'listing_type',
    'layout_specific',
    'bathrooms',
    'n',
    'geometry',
    'postal_code',
    'building_ownership',
    'min_price',
    'max_price',
    'listing_company',
    'building_address',
    'has_photos',
    'has_floorplan',
    'sort',
    'sort_dir',
    'unit_id',
    'search_id',
    'page',
    'per_page',
];
export const BUILDING_PRIMARY_FILTERS = [
    'page',
    'per_page',
    'canonical_building_id',
    'n',
    'geometry',
    'postal_code',
    'building_name_address',
    'listing_company',
    'owner_office',
    'company_buildings_only',
    'management_company',
    'building_q',
    'units__bathrooms',
    'units__layouts',
    'units__max_price',
    'units__min_price',
];

export const RENTER_HISTORY_FIELDS = [
    { label: 'Felony Record', value: 'felony_record_ok' },
    { label: 'Misdemeanor Record', value: 'misdemeanor_record_ok' },
    { label: 'Bankruptcy', value: 'bankruptcies_ok' },
    { label: 'Broken Leases', value: 'broken_leases_ok' },
    { label: 'Evictions', value: 'evictions_ok' },
    { label: 'Foreclosures', value: 'foreclosures_ok' },
];

export const ONSITE_ATTENDANCE_FIELDS = [
    { label: 'On-Site Management', value: 'onsite_management' },
    { label: 'On-Site Maintenance', value: 'onsite_maintenance' },
];

export const GARBAGE_DISPOSAL_FIELDS = [
    { label: 'On-Site Recycling', value: 'onsite_recycling' },
    { label: 'Valet Trash Service', value: 'valet_trash_service' },
    { label: 'Trash Disposal', value: 'trash_disposal' },
];

export const STORAGE_FIELDS = [
    { label: 'Bike Storage', value: 'bike_storage' },
    { label: 'Additional Storage', value: 'storage' },
];

export const ENTERTAINMENT_FIELDS = [
    { label: 'Community Wifi', value: 'community_wifi' },
    { label: 'Business Center', value: 'business_center' },
    { label: 'Playground', value: 'playground' },
    { label: 'Spa/Jacuzzi', value: 'spa_jacuzzi' },
    { label: 'Picnic/BBQ Area', value: 'picnic_bbq_area' },
    { label: 'Clubhouse', value: 'clubhouse' },
    { label: 'Game Room', value: 'game_room' },
    { label: 'Cinema Room', value: 'cinema_room' },
];

export const FITNESS_FIELDS = [
    { label: 'Fitness Center', value: 'fitness_center', advancedOnly: false },
    { label: 'Sports Court', value: 'sports_court', advancedOnly: true },
    { label: 'Swimming Pool', value: 'swimming_pool', advancedOnly: false },
    { label: 'Pet Park', value: 'pet_park', advancedOnly: true },
    { label: 'Jogging/Walking Trail', value: 'jogging_walking_trail', advancedOnly: true },
];

export const SAFETY_ACCESSIBILITY_FIELDS = [
    { label: 'Bus Pickup Route', value: 'bus_pickup_route' },
    { label: 'School Bus Pickup Route', value: 'school_bus_pickup_route' },
    { label: 'Handicap Accessible', value: 'handicap_accessible' },
    { label: 'Alarm System', value: 'alarm_system' },
    { label: 'Voice Intercom', value: 'voice_intercom' },
    { label: 'Gated', value: 'gated' },
    { label: 'Fenced Community', value: 'fenced_community' },
];

export const LAUNDRY_FIELDS = [
    { label: 'Laundry in Building', value: 'laundry_in_building' },
    { label: 'Dry Cleaning', value: 'dry_cleaning' },
];

export const ALT_ENTERTAINMENT_FIELDS = [
    { label: 'Community Wifi', value: 'community_wifi' },
    { label: 'Lounge', value: 'lounge' },
    { label: "Children's Playroom", value: 'childrens_playroom' },
];

export const MEDIA_OPTIONS = [
    { label: 'Has Photos', value: 'has_photos' },
    { label: 'Has Floorplans', value: 'has_floorplan' },
];

export const VIEW_VALUES = ['unit_extensions', 'featured', 'assigned'];
export const EXCLUDE_VALUES = ['user_can_syndicate'];

export const LAUNDRY_VALUES = LAUNDRY_FIELDS.map(option => option.value);
export const ALT_ENTERTAINMENT_VALUES = ALT_ENTERTAINMENT_FIELDS.map(option => option.value);
export const RENTER_HISTORY_VALUES = RENTER_HISTORY_FIELDS.map(option => option.value);
export const ONSITE_ATTENDANCE_VALUES = ONSITE_ATTENDANCE_FIELDS.map(option => option.value);
export const GARBAGE_DISPOSAL_VALUES = GARBAGE_DISPOSAL_FIELDS.map(option => option.value);
export const STORAGE_VALUES = STORAGE_FIELDS.map(option => option.value);
export const ENTERTAINMENT_VALUES = ENTERTAINMENT_FIELDS.map(option => option.value);
export const FITNESS_VALUES = FITNESS_FIELDS.map(option => option.value);
export const SAFETY_ACCESSIBILITY_VALUES = SAFETY_ACCESSIBILITY_FIELDS.map(option => option.value);

export const getEntertainmentValues = showAdvancedFilters =>
    showAdvancedFilters ? ENTERTAINMENT_VALUES : ALT_ENTERTAINMENT_VALUES;
export const getEntertainmentFields = showAdvancedFilters =>
    showAdvancedFilters ? ENTERTAINMENT_FIELDS : ALT_ENTERTAINMENT_FIELDS;
export const getFitnessValues = showAdvancedFilters =>
    showAdvancedFilters
        ? FITNESS_VALUES
        : filter(FITNESS_FIELDS, field => !field.advancedOnly).map(option => option.value);
export const getFitnessFields = showAdvancedFilters =>
    showAdvancedFilters ? FITNESS_FIELDS : filter(FITNESS_FIELDS, field => !field.advancedOnly);

export const BUILDING_FILTER_BUCKETS = [
    { name: 'Neighborhood', value: ['n'] },
    { name: 'Layout', value: ['units__layouts'] },
    { name: 'Bathrooms', value: ['units__bathrooms'] },
    { name: 'Price', value: ['units__min_price', 'units__max_price'] },
    { name: 'Management Company', value: ['management_company'] },
    { name: 'Listing Company', value: ['listing_company'] },
    { name: 'Owner/Office', value: ['owner_office'] },
    { name: 'Building', value: ['building_q'] },
    { name: 'Geometry', value: ['geometry'] },
    { name: 'Postal Code', value: ['postal_code'] },
    { name: 'Commissions', value: ['escort_rate', 'send_rate', 'tenant_specials'] },
    { name: 'Building Ownership', value: ['building_ownership'] },
    { name: 'Building Type', value: ['building_type'] },
    { name: 'Age', value: ['building_age'] },
    { name: 'Min Lease Term', value: ['lease_term'] },
    {
        name: 'Amenities',
        value: ['elevator', 'concierge', 'outdoor_space', 'package_room', 'doorman', 'virtual_doorman', 'parking']
            .concat(LAUNDRY_VALUES)
            .concat(ONSITE_ATTENDANCE_VALUES)
            .concat(GARBAGE_DISPOSAL_VALUES)
            .concat(STORAGE_VALUES)
            .concat(ENTERTAINMENT_VALUES)
            .concat(FITNESS_VALUES)
            .concat(SAFETY_ACCESSIBILITY_VALUES),
    },
    { name: 'Key in Office', value: ['key_in_office'] },
    {
        name: 'Pets',
        value: ['pets', 'pets_weight', 'pets_count', 'pets_no_interview_required', 'pets_no_breed_restriction'],
    },
    { name: 'Renter History', value: RENTER_HISTORY_VALUES },
    {
        name: 'Credit History',
        value: [
            'no_income_requirements',
            'no_credit_check_required',
            'accepts_first_time_renters',
            'accepts_co_signers',
        ],
    },
];

export const LISTING_FILTER_BUCKETS = [
    { name: 'Neighborhood', value: ['n'] },
    { name: 'Geometry', value: ['geometry'] },
    { name: 'Postal Code', value: ['postal_code'] },
    { name: 'Layout', value: ['layout_specific'] },
    { name: 'Bathrooms', value: ['bathrooms'] },
    { name: 'Price', value: ['min_price', 'max_price'] },
    { name: 'Listing Company', value: ['listing_company'] },
    { name: 'Building', value: ['building_address'] },
    { name: 'Building Ownership', value: ['building_ownership'] },
    { name: 'Off Market', value: ['off_market_status'] },
    { name: 'Exclude Pending', value: ['available_only'] },
    { name: "Exclude listings I can't syndicate", value: ['user_can_syndicate'] },
    { name: 'Date Available', value: ['date_available_after', 'date_available_before'] },
    { name: 'Open Houses', value: ['open_house_end', 'open_house_begin'] },
    { name: 'Listing Source', value: ['source'] },
    { name: 'Square Feet', value: ['max_square_footage', 'min_square_footage'] },
    { name: 'Min Lease Term', value: ['lease_term'] },
    {
        name: 'Pets',
        value: ['pets', 'pets_weight', 'pets_count', 'pets_no_interview_required', 'pets_no_breed_restriction'],
    },
    { name: 'Media', value: ['has_photos', 'has_floorplan'] },
    {
        name: 'Amenities',
        value: [
            'doorman',
            'laundry',
            'outdoor_space',
            'air_conditioning',
            'parking',
            'elevator',
            'concierge',
            'furnished',
        ]
            .concat(ONSITE_ATTENDANCE_VALUES)
            .concat(RENTER_HISTORY_VALUES)
            .concat(GARBAGE_DISPOSAL_VALUES)
            .concat(STORAGE_VALUES)
            .concat(ENTERTAINMENT_VALUES)
            .concat(FITNESS_VALUES)
            .concat(SAFETY_ACCESSIBILITY_VALUES),
    },
    { name: 'Key in Office', value: ['key_in_office'] },
    { name: 'Renter History', value: RENTER_HISTORY_VALUES },
    { name: 'My Actions', value: VIEW_VALUES },
    {
        name: 'Credit History',
        value: [
            'no_income_requirements',
            'no_credit_check_required',
            'accepts_first_time_renters',
            'accepts_co_signers',
        ],
    },
    {
        name: 'Commissions',
        value: [
            'escort_rate',
            'send_rate',
            'landlord_pays_fee',
            'tenant_specials',
            'incentives',
            'fee_structure',
            'show_open_listings_only',
        ],
    },
    { name: 'Syndication', value: ['syndicated_units', 'syndicating_agents', 'websites'] },
];

export const MONTHS = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
];

export const YEARS = [
    { value: '2018', label: '2018' },
    { value: '2019', label: '2019' },
    { value: '2020', label: '2020' },
    { value: '2021', label: '2021' },
    { value: '2022', label: '2022' },
];

export const SENTRY_DSN = 'https://93e71708d34e48a3b5fba3c6ef63fc79@o16407.ingest.sentry.io/1462349';

export const IMAGE_FILE_TYPES = [
    { fileType: 'image/png', displayName: 'png' },
    { fileType: 'image/gif', displayName: 'gif' },
    { fileType: 'image/jpeg', displayName: 'jpeg' },
    { fileType: 'application/pdf', displayName: 'pdf' },
];

export const DOCUMENT_FILE_TYPES = IMAGE_FILE_TYPES.concat([
    { fileType: 'application/msword', displayName: 'doc' },
    { fileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', displayName: 'docx' },
    { fileType: 'image/mpo', displayName: 'mpo' },
]);

export const ONE_MB_IN_BYTES = 1048576;

export const DEFAULT_ALLOWED_HTML_TAGS = [
    'span',
    'div',
    'a',
    'p',
    'hr',
    'br',
    'u',
    's',
    'strong',
    'em',
    'ul',
    'li',
    'ol',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'img',
    'table',
    'tr',
    'th',
    'td',
    'thead',
    'tbody',
    'tfoot',
    'caption',
    'font',
    'b',
];

export const TYPE_CONCESSION = 'concession';
export const TYPE_BASE_RENT = 'base_rent';

export const ASSET_GROUP_VISIBILITY_FULL = CHUCK_CONSTANTS.get('Role.ASSET_GROUP_VISIBILITY_FULL');
export const ASSET_GROUP_VISIBILITY_ASSET_GROUP = CHUCK_CONSTANTS.get('Role.ASSET_GROUP_VISIBILITY_ASSET_GROUP');
export const ASSET_GROUP_VISIBILITY_COMMUNITY = CHUCK_CONSTANTS.get('Role.ASSET_GROUP_VISIBILITY_COMMUNITY');
